module.exports = __webpack_public_path__ + "static/media/fiat.f954cd69.png";